import { appRoutingProviders, AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { AsistenteEnLineaModule } from './asistente-en-linea/asistente-en-linea.module';
import { FlexLayoutModule } from '@angular/flex-layout';
// CookieModule.forRoot() resuelve el error del parametro --prod
import { CookieModule } from "ngx-cookie";


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AsistenteEnLineaModule,
    AppRoutingModule,
    FlexLayoutModule,
    CookieModule.forRoot()
  ],
  providers: [
    appRoutingProviders,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
